
import SocialMediaType from '@/enums/SocialMediaType';

export default {
  i18nComponentKey: 'ReviewsShow.components.EmbeddedSocialMediaReview',
  name: 'EmbeddedSocialMediaReview',
  props: {
    review: { type: Object, required: true }
  },
  computed: {
    SocialMediaType: () => SocialMediaType
  }
};
